import { render, staticRenderFns } from "./share-dialog.vue?vue&type=template&id=2f1bd1c7&scoped=true&"
import script from "./share-dialog.vue?vue&type=script&lang=js&"
export * from "./share-dialog.vue?vue&type=script&lang=js&"
import style0 from "./share-dialog.vue?vue&type=style&index=0&id=2f1bd1c7&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2f1bd1c7",
  null
  
)

export default component.exports